import {ServiceBase} from '../ServiceBase';
import {onINP} from "web-vitals/attribution";
import {IINPData, IWebVitalsService} from "./web-vitals.service.interface";

export class WebVitalsService extends ServiceBase implements IWebVitalsService{

    init(){
        setTimeout(() => {
            onINP(this._sendToElastic.bind(this));
        }, 5000);
    }

    private _sendToElastic ({name, value, id, attribution}) {
        const {eventEntry, eventTarget, eventType, loadState} = attribution;
        const {startTime, processingStart, processingEnd, duration, interactionId, target} = eventEntry;
        const INPData:IINPData  = {
            event_target: eventTarget,
            load_state: loadState,
            start_time: startTime,
            processing_start: processingStart,
            processing_end: processingEnd,
            duration: duration,
            interaction_id: interactionId,
            target_text:(target?.innerText ? target.innerText.substring(0,30) : "no target")
        };

        // eventType is the type of event that triggered the interaction:
        // id is a unique ID for the page session, which is useful for computing totals when you group by the ID.
        // value is the page's INP value;
        this.services.sdk.structuredLoggingService
            .getLogger()
            .setTarget('casino-orbit-web-vitals')
            .addCategory("ORBIT_INP")
            .addAction(eventType)
            .addLabel(id)
            .addValue(value)
            .addCustomData(INPData)
            .info();
    }
}
